import { SnackbarOrigin } from "@material-ui/core";
import { AlertProps } from "@material-ui/lab/Alert";
import { changeAppState } from "../../../common/appState";
import { SnackbarState } from "./type";

export function showSnackbar(
    message: string,
    severity: AlertProps["severity"] = "success",
    autoHideDuration: number = 6000, // デフォルトは6秒
    anchorOrigin?: SnackbarOrigin
) {
    changeAppState("snackbarState", {
        open: true,
        message: message,
        severity: severity,
        autoHideDuration: autoHideDuration,
        anchorOrigin: anchorOrigin,
    } as SnackbarState);
}

export function hideSnackbar() {
    changeAppState("snackbarState", {
        open: false,
    });
}
